import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import LoadingScreen from '../common/LoadingScreen';
import { landingPathForRole } from '../../lib/roleRouting';

const AdminRoute = () => {
  const { user, profile, profileLoaded } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Cette garde s'appuyait sur `isLoading` de authStore, qui vaut false a
  // l'initialisation : elle n'attendait donc jamais. Apres un rafraichissement
  // le profil n'etait pas encore charge, le role paraissait inconnu, et
  // l'administrateur etait renvoye vers l'espace parent.
  if (!profileLoaded) {
    return <LoadingScreen />;
  }

  const role = (user.app_metadata?.role as string) || profile?.role;

  if (role !== 'admin') {
    return <Navigate to={landingPathForRole(role)} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
